import axiosInstance from "../Utils/axiosConfig";

const getSettings = async () => {
  const response = await axiosInstance.get(
    `${process?.env?.REACT_APP_API_REST_URL}/api/GetSettings`
  );
  return response?.data;
};

const getLanguageList = async () => {
  const response = await axiosInstance.get(
    `${process?.env?.REACT_APP_API_REST_URL}/api/language_list`
  );
  return response?.data;
};

const getCurrencySettings = async () => {
  const response = await axiosInstance.get(
    `${process?.env?.REACT_APP_API_REST_URL}/api/CurrencySettings`
  );
  return response?.data;
};

const settingsService = {
  getSettings,
  getLanguageList,
  getCurrencySettings,
};

export default settingsService;
